export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // Fixed navigation animation
    var scrolled = false;
    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var navbar = $('nav.navbar');
      if ( scroll > 20 && ! scrolled) {
        navbar.animate({'margin-top': '-40px'}, 100);
        scrolled = true;
      }
      if ( scroll < 20 && scrolled ) {
        navbar.animate({'margin-top': '0'}, 300);
        scrolled = false;
      }
    });

    // Offerte styling changes
    var nextButtons = $('.cf7mls_next');
    for ( var i = 0; i < nextButtons.length; i++ ) {
      nextButtons[i].innerHTML = 'Volgende stap';
    }
    var previousButtons = $('.cf7mls_back');
    for ( var s = 0; s < previousButtons.length; s++ ) {
      previousButtons[s].innerHTML = 'Vorige stap';
    }

    var formSteps = $('fieldset.fieldset-cf7mls');
    var spacers = $('div.spacer');
    $('.cf7mls_next').on('click', function() {
      for ( var f = 0; f < formSteps.length; f++ ) {
        if ( $(formSteps[f]).css('visibility') != 'hidden' ) {
          var temp = f + 1;
          $(spacers[temp]).addClass('active');
        }
      }
    });

    $('.sub_location-plus').on('click', function() {
      $(this).css('display', 'none');
      var hiddenSubLocations = $('div.sub_location_div-hidden');
      for ( var h = 0; h < hiddenSubLocations.length; h++ ) {
        if ( $(hiddenSubLocations[h]).css('display') == 'none' ) {
          $(hiddenSubLocations[h]).css('display', 'flex');
          break;
        }
      }
    });

    document.addEventListener( 'wpcf7mailsent', function( ) {
      location = '/bedankt';
    }, false );

  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js